import { z } from "zod";

export const adminOperatorSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  displayName: z.string().trim().min(1).max(120).optional(),
  status: z.enum(["ACTIVE", "BANNED", "DISABLED"]).optional()
});

export const authSessionDataSchema = z.object({
  authenticated: z.boolean(),
  csrfToken: z.string().min(16).max(512).optional(),
  operator: adminOperatorSchema.optional()
});

export const authSuccessSchema = z.object({
  success: z.literal(true),
  data: authSessionDataSchema
});

export const logoutSuccessSchema = z.object({
  success: z.literal(true),
  data: z.object({ loggedOut: z.literal(true) })
});

export const authFailureSchema = z.object({
  success: z.literal(false),
  error: z.object({
    code: z.string(),
    message: z.string(),
    requestId: z.string()
  })
});

export const loginFormSchema = z.object({
  identifier: z.string().trim().min(3, "Informe seu e-mail ou identificador."),
  password: z.string().min(1, "Informe sua senha.").max(128, "A senha informada é muito longa.")
});

export type AdminOperator = z.infer<typeof adminOperatorSchema>;
export type AuthSessionData = z.infer<typeof authSessionDataSchema>;
export type LoginFormValues = z.infer<typeof loginFormSchema>;

export interface LoginInput {
  identifier: string;
  password: string;
}
